import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function ChildPainting() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Grid spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={8}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                第９回こども絵画コンクール
              </Typography>
                　デーリー東北新聞社は、第９回「こども絵画コンクール」を開催します。絵画への取り組みを通じて、感性豊かな子どもの育成を目指します。<br />
                　対象は青森、岩手両県内の３歳以上の幼児から中学生まで（特別支援学級を含む）。<br />
                　テーマは自由です。<br />
                　締め切りは2023年１月20日（金）。入賞作品は２月に紙上で発表後、デーリー東北ホール（本社１階）で展示します。<br />
            </Grid>
            <Grid item xs={12} md={4}>
              <Box p={2} textAlign="center">
                <img src="/images/childpainting/poster.jpg" className="img-fluid" />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            コンクール実施要項
          </Typography>
          <dl>
            <dt>応募資格</dt>
            <dd>
              青森・岩手両県内の３歳～中学生（特別支援学級を含む）
            </dd>
            <Divider className="my-4" />
            <dt>部　　門</dt>
            <dd>
              <ul>
                <li>幼児の部（３歳以上小学生未満）</li>
                <li>小学校低学年の部（１～２年生）</li>
                <li>小学校中学年の部（３～４年生）</li>
                <li>小学校高学年の部（５～６年生）</li>
                <li>中学生の部</li>
              </ul>
            </dd>
            <Divider className="my-4" />
            <dt>作品規定</dt>
            <dd>
              <ul>
                <li>テーマは自由です。</li>
                <li>市販の画用紙（サイズ指定「四つ切」縦392mm×横542mm）を使用。画材は問いません。ただし、版画、切り絵、貼り絵は不可。</li>
                <li>一人1作品、未発表の作品とします。</li>
              </ul>
            </dd>
            <Divider className="my-4" />
            <dt>応募方法</dt>
            <dd>
              <Typography className="font-weight-bold my-3" variant="body1" component="h2">
                【STEP1】<br/>申し込みフォームに必要事項を入力<br />
                <u>※応募作品を持参、郵送する前に入力してください。</u>
              </Typography>
              <Box my={4} textAlign="center">
                <Grid className="px-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    {/* <CustomButton href="https://docs.google.com/forms/d/e/1FAIpQLSd4_eg8Y81ps65fpGAx8E5qVLK3PCdywKKcYRDsRKop9Wlcqg/viewform" target="_blank" className="px-4 m-2 d-block" size="large" themeColor={teal}> */}
                    <CustomButton href="https://docs.google.com/forms/d/1PV_1istLnnIyP_AVPRDt0jwE04U-l8jumTJN2Oxrigo/edit" target="_blank" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      個人で応募する
                    </CustomButton>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    {/* <CustomButton href="https://docs.google.com/forms/d/e/1FAIpQLSfgLW-LC6LgSl8xul2tuI_vKHeJr3_-PRrHyfatDkFxQWmdBA/viewform" target="_blank" className="px-4 m-2 d-block" size="large" themeColor={teal}> */}
                    <CustomButton href="https://docs.google.com/forms/d/1r0eoELv8PoJ5hd_tUSkVI7-TZAGpia0wxTUqdFrATn8/edit" target="_blank" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      団体で応募する
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
              <Typography className="font-weight-bold my-3" variant="body1" component="h2">
                【STEP2】<br/>応募用紙を記入し、作品の裏側に貼付
              </Typography>
              <Box my={4} textAlign="center">
                <Grid className="px-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="https://event-guide.daily-tohoku.news/wp-content/themes/info/assets/pdf/childpainting/oubo.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      応募用紙をダウンロード
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
              <Typography className="font-weight-bold my-3" variant="body1" component="h2">
                【STEP3】<br/>応募する作品をデーリー東北新聞社　本社（青森県八戸市城下１丁目3-12）まで持参又は郵送
              </Typography>
            </dd>
            <Divider className="my-4" />
            <dt>応募締切</dt>
            <dd>2023年1月20日（金）必着</dd>
            <Divider className="my-4" />
            <dt>発　　表</dt>
            <dd>2月中旬に「デーリー東北」紙上で、各部門の入賞者の氏名、学校名を掲載します。</dd>
            <Divider className="my-4" />
            <dt>表　　彰</dt>
            ※各部門ごとに
            <dd>
              <ul>
                <li>最優秀賞１点・・・賞状、副賞</li>
                <li>優秀賞　２点・・・賞状、副賞</li>
                <li>入選　　５点・・・賞状、副賞</li>
                <li>佳作　１０点・・・賞状、副賞</li>
                <li>優秀学校賞　・・・幼稚園・保育園、小学校、中学校より各1校</li>
              </ul>
            </dd>
            <Divider className="my-4" />
            <dt>表彰式</dt>
            <dd>
              2023年2月中に実施<br />
              デーリー東北新聞社　本社<br />
              （新型コロナウイルス感染症拡大状況により、行わない場合もございます）<br />
            </dd>
            <Divider className="my-4" />
            <dt>作品展示</dt>
            <dd>
              2023年2月18日（土）〜2月20日（月）<br />
              デーリー東北ホール（本社１階）<br />
            </dd>
          </dl>
          <Divider className="my-4" />
          <dt>その他</dt>
          <dd>
            <ul>
              <li>応募の際に記載いただく個人情報は、本事業に関する確認、連絡のみに使用し、適切に取り扱います。</li>
              <li>応募作品の本社紙面への掲載についての権利は、デーリー東北新聞社に帰属します。</li>
              <li>希望者には、応募作品を返却いたします。※３月中旬までに来社できる方のみ</li>
            </ul>
          </dd>
          <Divider className="my-4" />
          <dl>
            <dt>応募・お問い合わせ先</dt>
            <dd>
              デーリー東北新聞社 コミュニティー事業部「こども絵画コンクール」係<br/>
              〒031-8601 青森県八戸市城下1丁目3-12<br/>
              TEL:0178-80-7299（平日10:00〜17:00）<br/>
              Mail:<a href="mailto:kaiga@daily-tohoku.co.jp">kaiga@daily-tohoku.co.jp</a><br/>
            </dd>
          </dl>
        </Box>
      </div>
    </div>
  );
}

export default ChildPainting;
